import { useEffect, useState } from 'react';

const usePersistedState = (key, defaultValue, options = {}) => {
  const { persistBooleans = false } = options;

  const [value, setValue] = useState(() => {
    const currentValue = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    const localValue = key && localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : currentValue;
    return localValue;
  });

  useEffect(() => {
    if (key) {
      const shouldPersist = persistBooleans ? value !== null : value;
      shouldPersist ? localStorage.setItem(key, JSON.stringify(value)) : localStorage.removeItem(key);
    }
  }, [key, value, persistBooleans]);

  return [value, setValue];
};

export default usePersistedState;
